module.exports = __webpack_public_path__ + "k.no2.29ae86cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/k.no2.jpg
// module id = 57tB
// module chunks = 0